namespace Gamification.Gamification {
    export interface ProdottiForm {
        IdentifierProdotto: Serenity.StringEditor;
        IdProdotto: Serenity.IntegerEditor;
        UserIdRagioneSociale: Serenity.StringEditor;
        UserIdNominativo: Serenity.StringEditor;
        IdTipologiaProdotti: Serenity.LookupEditor;
        Nome: Serenity.StringEditor;
        Descrizione: Serenity.TextAreaEditor;
        Bozza: Serenity.BooleanEditor;
        IdentifierPunteggio: Serenity.StringEditor;
        PunteggioNome: Serenity.StringEditor;
        PunteggioValoreIniziale: Serenity.IntegerEditor;
        PunteggioNegativo: Serenity.BooleanEditor;
        IdentifierCrediti: Serenity.StringEditor;
        CreditiNome: Serenity.StringEditor;
        CreditiValoreIniziale: Serenity.IntegerEditor;
        IdentifierEsperienza: Serenity.StringEditor;
        EsperienzaNome: Serenity.StringEditor;
        EsperienzaValoreIniziale: Serenity.IntegerEditor;
        BadgeList: ProdottiBadgeEditor;
        ClassiList: ProdottiClassiEditor;
        LivelliList: ProdottiLivelliEditor;
        EsperienzeList: ProdottiEsperienzeEditor;
        RisorseList: ProdottiRisorse2Editor;
    }

    export class ProdottiForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.Prodotti';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProdottiForm.init)  {
                ProdottiForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.LookupEditor;
                var w3 = s.TextAreaEditor;
                var w4 = s.BooleanEditor;
                var w5 = ProdottiBadgeEditor;
                var w6 = ProdottiClassiEditor;
                var w7 = ProdottiLivelliEditor;
                var w8 = ProdottiEsperienzeEditor;
                var w9 = ProdottiRisorse2Editor;

                Q.initFormType(ProdottiForm, [
                    'IdentifierProdotto', w0,
                    'IdProdotto', w1,
                    'UserIdRagioneSociale', w0,
                    'UserIdNominativo', w0,
                    'IdTipologiaProdotti', w2,
                    'Nome', w0,
                    'Descrizione', w3,
                    'Bozza', w4,
                    'IdentifierPunteggio', w0,
                    'PunteggioNome', w0,
                    'PunteggioValoreIniziale', w1,
                    'PunteggioNegativo', w4,
                    'IdentifierCrediti', w0,
                    'CreditiNome', w0,
                    'CreditiValoreIniziale', w1,
                    'IdentifierEsperienza', w0,
                    'EsperienzaNome', w0,
                    'EsperienzaValoreIniziale', w1,
                    'BadgeList', w5,
                    'ClassiList', w6,
                    'LivelliList', w7,
                    'EsperienzeList', w8,
                    'RisorseList', w9
                ]);
            }
        }
    }
}
